import React from 'react';
import RichEditor from 'src/view/components/rich-editor';
import './index.scss';
export default function ReleaseNote(props) {
    const { data } = props;
    if (!data?.releaseNotesContent) {
        return null;
    }
    return (React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-rich-text-render' },
        React.createElement(RichEditor, { content: data.releaseNotesContent, fileList: data.fileList })));
}
